"use strict";

import axios from "axios";
import { injectToken } from "./injectToken.js";

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_DUBFROG_BASE_SERVER_URL,
});

export const normalizeApiError = (error) => {
    const status = error.response?.status ?? null;
    const responseData = error.response?.data;
    const message = responseData?.message
        || responseData?.error
        || error.message
        || "An unexpected error occurred";

    return {
        message,
        status,
        data: responseData ?? null,
        originalError: error,
    };
};

apiClient.interceptors.request.use(async (config) => {
    const tokenHeaders = await injectToken();

    if (!tokenHeaders) {
        return config;
    }

    return {
        ...config,
        headers: {
            ...tokenHeaders,
            ...config.headers,
        },
    };
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        error.normalized = normalizeApiError(error);
        return Promise.reject(error);
    }
);

export default apiClient;
